import { createFileRoute } from "@tanstack/react-router";
import { OmOsPage, omosHead } from "@/pages/OmOsPage";

export const Route = createFileRoute("/en/about-us")({
  head: () => omosHead("en"),
  component: () => <OmOsPage locale="en" />,
});
